import { z } from 'zod';

import { Summary, SummaryLike } from '../summary';
import { entityTypeSchema } from './metadata-association';
import { deltaKindSchema } from './sync';

/**
 * An object ID originating from the external data source Edlink.
 */
export const edlinkIdSchema = z.string().brand<'edlinkId'>();
export const EdlinkId = edlinkIdSchema.parse.bind(edlinkIdSchema);
export type EdlinkId = z.infer<typeof edlinkIdSchema>;

export const edlinkDistrictEntrySchema = z.object({
  integrationId: edlinkIdSchema,
  districtId: edlinkIdSchema,
  districtName: z.string(),
});
export type EdlinkDistrictEntry = z.infer<typeof edlinkDistrictEntrySchema>;

export const edlinkOrgChartImportSuccessSchema = z.object({
  type: entityTypeSchema,
  kind: deltaKindSchema,
  internalId: z.string().optional(),
  externalId: edlinkIdSchema.optional(),
});
export type EdlinkOrgChartImportSuccess = z.infer<typeof edlinkOrgChartImportSuccessSchema>;

export const edlinkOrgChartImportFailureSchema = z.object({
  type: entityTypeSchema,
  kind: deltaKindSchema,
  internalId: z.string().optional(),
  externalId: edlinkIdSchema.optional(),
  error: z.instanceof(Error),
});
export type EdlinkOrgChartImportFailure = z.infer<typeof edlinkOrgChartImportFailureSchema>;

export class EdlinkOrgChartImportSummary extends Summary<EdlinkOrgChartImportSuccess, EdlinkOrgChartImportFailure> {
  get items() {
    return this.results;
  }

  get failureItems() {
    return this.failures;
  }

  get skipsCount() {
    return this.skipped;
  }
}
export type EdlinkOrgChartImportSummaryLike = SummaryLike<EdlinkOrgChartImportSuccess, EdlinkOrgChartImportFailure>;

export const edlinkOrgChartDryRunItemSchema = z.object({
  delta: entityTypeSchema,
  kind: deltaKindSchema,
  label: z.string().optional(),
  details: z.record(z.string(), z.string()).optional(),
});
export type EdlinkOrgChartDryRunItem = z.infer<typeof edlinkOrgChartDryRunItemSchema>;
export type EdlinkOrgChartDryRunResult = EdlinkOrgChartDryRunItem[];
